<template>
    <analytics-category-card
        :category="category"
        :loading="loading"
        :href="`/analytics/franchise-hub/${props.category.value}?${stringifyQueryString(fetchParams)}`"
    >
        <div v-if="!loading" class="flex flex-col gap-2">
            <category-metric-row
                v-for="(metric, index) in metricsData"
                :fetchParams="props.fetchParams"
                :key="`${props.category.value}_${metric.metric}`"
                :modelValue="metricsData[index]"
            ></category-metric-row>
        </div>
    </analytics-category-card>
</template>

<script setup>
import { computed, watch } from 'vue';
import { outboundMessagesAnalyticsClient } from '~/services/index';
import { useVersionedRequest } from '~/composables/useVersionedRequest';
import { metricsInputValidator, metricsWithGoals } from '~/utils/analytics';
import CategoryMetricRow from '~/components/analytics/partial/category-metrics/CategoryMetricRow.vue';
import AnalyticsCategoryCard from '~/components/analytics/partial/category-metrics/AnalyticsCategoryCard.vue';
import { stringifyQueryString } from '~/utils/string';

const teamId = Spark.state.currentTeam.id;

const { loading, response, error, fetchData } = useVersionedRequest();

const props = defineProps({
    category: {
        type: Object,
        required: true,
    },
    fetchParams: {
        type: Object,
        required: true,
        validator: metricsInputValidator,
    },
    href: {
        type: String,
    },
});

const metricsData = computed(() => {
    const metrics = response.value?.data?.data?.filter((result) => result.category === props.category.value);

    if (error.value || !metrics || !metrics.length) {
        const emptyMetricsData = {
            num_below_target: 0,
            num_above_target: 0,
            target: 0,
        };

        return metricsWithGoals.map((metric) => ({ ...emptyMetricsData, metric }));
    }

    return metrics.sort((a, b) => {
        return metricsWithGoals.indexOf(a.metric) - metricsWithGoals.indexOf(b.metric);
    });
});

watch(
    () => props.fetchParams,
    () => {
        // pass fetchParams without the category to get data for all categories
        fetchData(outboundMessagesAnalyticsClient.getGroupPerformanceByCategory({ teamId }, props.fetchParams)).catch(
            (e) => {
                console.error(e);
            }
        );
    },
    { immediate: true, deep: true }
);
</script>
